import type {
  CreatePrintDocumentData,
  UpdatePrintDocumentFileUploadStatusData,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type PrintDocument,
  type PrintDocumentCreation,
  PrintDocumentCreationSchema,
  PrintDocumentSchema,
} from './schemas'

const ENTITY = 'PrintDocument'

export const adaptPrintDocumentCreation = (raw: CreatePrintDocumentData): PrintDocumentCreation =>
  parseApiResponse(PrintDocumentCreationSchema, raw, ENTITY)

export const adaptPrintDocument = (raw: UpdatePrintDocumentFileUploadStatusData): PrintDocument =>
  parseApiResponse(PrintDocumentSchema, raw, ENTITY)
